<nav
    id="navigation"
    [ngClass]="{
        navbar: true,
        'navbar-expand-md': collapseForMobile,
        'navbar-expand': !collapseForMobile,
        'navbar-dark bg-dark': false,
        'navbar-light': true
    }"
>
    <div
        id="navbar-container-fluid"
        class="container-fluid"
        [ngClass]="{ 'page-container': useMaxWidth }"
    >
        <a
            class="navbar-brand"
            aria-label="LSQ logo; navigate to homepage"
            [ngClass]="{ 'navigation-hidden': hideNavigation }"
            [routerLink]="getHomeUrl()"
        >
            <ng-container *ngIf="!!navLogoTemplate">
                <ng-container *ngTemplateOutlet="navLogoTemplate"></ng-container>
            </ng-container>
            <lsq-icon
                *ngIf="!navLogoTemplate"
                [type]="icons.FastTrackLogo"
                [color]="color.Black"
                [showBeta]="showBetaLogo"
            >
            </lsq-icon>
        </a>

        <!-- Mobile Navigation Bar -->
        <div
            *ngIf="
                collapseForMobile &&
                !hideNavigation &&
                (responsiveService.mdBelow | async) &&
                ((isLoggedIn$ | async) || state.navigationItems?.some(isAllowAnonymous))
            "
        >
            <div class="navbar-nav pull-right navbar-nav-mobile">
                <!-- ContentChildren nav items get inserted here -->
                <ng-container *ngIf="rightNavItems">
                    <ng-container *ngTemplateOutlet="rightNavItems"> </ng-container>
                </ng-container>

                <div class="nav-item icon-nav-item">
                    <a
                        class="nav-link icon-nav-link"
                        href="javascript:void(0)"
                        role="button"
                        (click)="openMobileNavigation()"
                    >
                        <lsq-icon [type]="icons.Hamburger" [color]="color.Black"> </lsq-icon>
                    </a>
                </div>
            </div>
        </div>

        <!-- Fullsize Navigation Bar -->
        <div
            *ngIf="!hideNavigation && !(responsiveService.mdBelow | async)"
            class="navbar-collapse"
            [ngClass]="{ collapse: collapseForMobile }"
            id="navbarNav"
        >
            <!-- Left Navigation Items -->
            <ul
                class="navbar-nav mr-auto"
                id="navbar-nav-left"
                [ngClass]="{ 'link-is-hovered': isSomeNavLinkHovered() }"
            >
                <ng-container
                    *ngFor="
                        let navigationItem of hideNavigationItems ? [] : state.navigationItems;
                        let i = index
                    "
                >
                    <ng-container
                        *ngIf="
                            ((isLoggedIn$ | async) || navigationItem.allowAnonymous) &&
                            !navigationItem.hideInDesktop
                        "
                    >
                        <ng-container *featureFlag="navigationItem.featureFlags">
                            <ng-container *environments="navigationItem.environments">
                                <li
                                    *claimsOr="navigationItem.claims"
                                    class="nav-item"
                                    (mouseenter)="showChildren(navigationItem, i)"
                                    (mouseleave)="showChildren(navigationItem, i, false)"
                                    [ngClass]="getNavigationItemClassList(navigationItem)"
                                    [routerLinkActive]="navigationItem.routerLinkActive"
                                    [routerLinkActiveOptions]="
                                        navigationItem.routerLinkActiveOptions
                                    "
                                >
                                    <a
                                        [ngClass]="[
                                            'nav-link',
                                            navigationItem.icon ? classNames.HasIcon : '',
                                            navigationItem.linkClassName
                                                ? navigationItem.linkClassName
                                                : ''
                                        ]"
                                        [routerLink]="navigationItem.routerLink"
                                        [queryParams]="navigationItem.queryParams"
                                        [attr.aria-haspopup]="
                                            !!(
                                                navigationItem.children?.length &&
                                                showNavigationChildren &&
                                                !navigationItem.hideChildren
                                            )
                                        "
                                        [attr.aria-expanded]="!!navigationItem.showChildren"
                                        (keydown)="handleNavLinkKeyDown($event, navigationItem, i)"
                                        (mouseenter)="handleNavLinkMouseEnter(i)"
                                        (mouseleave)="handleNavLinkMouseLeave(navigationItem, i)"
                                    >
                                        <div class="nav-link-content">
                                            <lsq-icon
                                                *ngIf="!!navigationItem.icon"
                                                [type]="navigationItem.icon"
                                            >
                                            </lsq-icon>
                                            <span>{{ navigationItem.label }}</span>
                                            <span
                                                *ngIf="
                                                    navigationItem.children?.length &&
                                                    showNavigationChildren &&
                                                    !navigationItem.hideChildren
                                                "
                                                class="sr-only"
                                            >
                                                (press the space bar to expand the sub-menu)
                                            </span>
                                            <span class="counter" *ngIf="navigationItem.counter">{{
                                                navigationItem.counter
                                            }}</span>
                                        </div>
                                    </a>
                                    <lsq-dropdown-navigation
                                        *ngIf="
                                            navigationItem.children?.length &&
                                            showNavigationChildren &&
                                            !navigationItem.hideChildren
                                        "
                                        [items]="navigationItem.children"
                                        [isLoggedIn]="isLoggedIn$ | async"
                                        [(show)]="navigationItem.showChildren"
                                        (select)="navigationItem.showChildren = false"
                                    >
                                    </lsq-dropdown-navigation>
                                </li>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ul>

            <ul class="navbar-nav pull-right" id="navbar-nav-right">
                <!-- ContentChildren nav items get inserted here -->
                <ng-container *ngIf="rightNavItems && (isLoggedIn$ | async)">
                    <ng-container *ngTemplateOutlet="rightNavItems"></ng-container>
                </ng-container>

                <!-- ContentChildren nav items get inserted here for when someone is logged out-->
                <ng-container *ngIf="loggedOutRightNavItems && !(isLoggedIn$ | async)">
                    <ng-container *ngTemplateOutlet="loggedOutRightNavItems"> </ng-container>
                </ng-container>

                <!-- Account Menu -->
                <li
                    *ngIf="
                        (state.desktopSettingsDropdownNavigationItems?.length ||
                            forceRenderAccountDropdown) &&
                        ((isLoggedIn$ | async) ||
                            state.desktopSettingsDropdownNavigationItems?.some(isAllowAnonymous))
                    "
                    id="account-nav-item"
                    class="nav-item icon-nav-item"
                >
                    <a
                        id="account-{{ classNames.DropdownToggle }}"
                        class="nav-link icon-nav-link"
                        href="javascript:void(0)"
                        role="button"
                        aria-label="Click to toggle the Account menu"
                        aria-haspopup="true"
                        [attr.aria-expanded]="gearDropdownIsExpanded"
                        (click)="toggleGearDropdown()"
                        (clickOutside)="closeGearDropdown()"
                        exclude="#account-nav-item"
                    >
                        <span
                            id="account-{{ classNames.DropdownToggle }}-icon"
                            class="{{ classNames.DropdownToggle }}-icon"
                            [ngClass]="{ 'circle-bg': isLoggedIn$ | async }"
                        >
                            <lsq-icon
                                *ngIf="isLoggedIn$ | async"
                                [type]="icons.Person"
                                [color]="color.White"
                                [width]="18"
                                [height]="18"
                            >
                            </lsq-icon>
                            <lsq-icon
                                *ngIf="!(isLoggedIn$ | async)"
                                [type]="icons.Gear"
                                [ngClass]="{ 'is-rotated': gearDropdownIsExpanded }"
                            >
                            </lsq-icon>
                        </span>
                    </a>

                    <lsq-dropdown-navigation
                        *ngIf="
                            state.desktopSettingsDropdownNavigationItems?.length ||
                            forceRenderAccountDropdown
                        "
                        [isLoggedIn]="isLoggedIn$ | async"
                        [shouldAnimate]="true"
                        [items]="state.desktopSettingsDropdownNavigationItems"
                        [triangle]="false"
                        [prependItems]="settingsDropdownPrepend"
                        [appendItems]="settingsDropdownAppend"
                        [(show)]="gearDropdownIsExpanded"
                        (select)="closeGearDropdown()"
                    >
                    </lsq-dropdown-navigation>
                </li>
            </ul>
        </div>
    </div>
</nav>
